var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"odr-row__col",class:{
         'odr-row__col_fixed': _vm.fixed === 'true',
         'odr-row__col_half': _vm.half === 'true',
         'odr-row__col_no-margin': _vm.noMargin === 'true',
         'odr-row__col_half-margin': _vm.halfMargin === 'true'
     }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }